import React, { useState } from 'react';
import { X, Edit2, Phone } from 'lucide-react';
import api from '../../utils/api';

function EditPhoneModal({ phone, onClose, onSuccess }) {
  const [phoneName, setPhoneName] = useState(phone.phone_name || '');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (!phoneName.trim()) {
      setError('Please enter a label');
      return;
    }

    setSubmitting(true);
    try {
      const resp = await api.patch(`/api/sms/phones/${phone.id}`, {
        phoneName: phoneName.trim(),
      });

      if (resp.data?.success) {
        onSuccess();
      } else {
        setError('Failed to update phone label');
      }
    } catch (err) {
      console.error('Error updating phone:', err);
      setError(err.response?.data?.error || 'Failed to update phone label');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 flex-shrink-0">
              <Edit2 className="w-5 h-5 text-blue-600" />
            </div>
            <h2 className="text-lg sm:text-xl font-bold text-gray-900">Edit Phone Label</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 min-w-[44px] min-h-[44px] flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-4">
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <span className="text-sm text-red-700">{error}</span>
            </div>
          )}

          <div className="p-3 bg-gray-50 rounded-lg flex items-center gap-3">
            <Phone className="w-5 h-5 text-gray-400" />
            <div className="flex-1">
              <div className="text-sm text-gray-600">Phone Number</div>
              <div className="font-medium text-gray-900">{phone.phone_number}</div>
            </div>
          </div>

          <div>
            <label className="block text-base sm:text-sm font-medium text-gray-700 mb-2">
              Label
            </label>
            <input
              type="text"
              value={phoneName}
              onChange={(e) => setPhoneName(e.target.value)}
              placeholder="e.g., Mobile, Work Phone"
              className="w-full px-3 py-2 text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              autoFocus
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2.5 sm:py-2 px-4 min-h-[44px] border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 py-2.5 sm:py-2 px-4 min-h-[44px] bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
            >
              {submitting ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditPhoneModal;
